import type { YieldFileType } from '@/features/assets/constants'
import { createClient } from '@/shared/api/client'
import { TargetSystem } from '@/shared/constants'
import { buildUrl } from '@/shared/utils/urls'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export async function attachYieldFile(assetCode: string, { fileType, uploadId } : { fileType: YieldFileType, uploadId: string }) {
  await client.sendPut(`assets/${assetCode}/yields/files`, {
    data: {
      type: fileType,
      uploadId,
    }
  })
}
